<template>
    <div class="row">
        <div class="col-12">
            <div id="itb-slider">
                <Slides :image="images[chosenImage]" />

                <div
                    class="container-xl"
                    style="padding: 0 0.5rem; position: relative"
                >
                    <div
                        v-if="images.length > 1"
                        title="previous image"
                        class="itb-arrow-left"
                        @click="arrowLeft()"
                    >
                        <i class="ci-chevron_big_left"></i>
                    </div>
                    <div
                        v-if="images.length > 1"
                        title="next image"
                        class="itb-arrow-right"
                        @click="arrowRight()"
                    >
                        <i class="ci-chevron_big_right"></i>
                    </div>
                    <div class="controls d-flex justify-content-center">
                        <div
                            v-for="(image, index) in images"
                            :class="
                                'options ' +
                                (index === chosenImage ? 'active' : '')
                            "
                            @click="squares(index)"
                            :key="index"
                        >
                            <span>{{ image.title }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Slides from "./Slides.vue";
export default {
    components: {
        Slides,
    },
    data() {
        return {
            images: [],
            intervalDuration: 600000,
            chosenImage: 0,
            intervalObject: null,
            pauseplayToggle: false, //false - play, true - pause
        };
    },
    methods: {
        squares(index) {
            this.chosenImage = index;
            clearInterval(this.intervalObject);
            this.setIntervalSlider("right");
            this.pauseplayToggle = false;
        },
        arrowLeft() {
            clearInterval(this.intervalObject);
            this.moveLeft();
            this.setIntervalSlider("left");
        },
        arrowRight() {
            clearInterval(this.intervalObject);
            this.moveRight();
            this.setIntervalSlider("right");
        },
        moveLeft() {
            var flag = this.chosenImage;
            flag--;
            if (flag < 0) {
                flag = this.images.length - 1;
            }
            this.chosenImage = flag;
            this.pauseplayToggle = false;
        },
        moveRight() {
            var flag = this.chosenImage;
            flag++;
            if (flag >= this.images.length) {
                flag = 0;
            }
            this.chosenImage = flag;
            this.pauseplayToggle = false;
        },
        pauseplay(action) {
            console.log("in pauseplay method ", action);
            if (action == "play") {
                this.itb - arrow - right();
                this.pauseplayToggle = false;
            } else if (action == "pause") {
                clearInterval(this.intervalObject);
                this.pauseplayToggle = true;
            }
        },
        setIntervalSlider(direction) {
            var self = this;
            this.intervalObject = setInterval(() => {
                if (direction == "right") {
                    self.moveRight();
                } else if (direction == "left") {
                    self.moveLeft();
                }
            }, this.intervalDuration);
        },
        async getLatestImages() {
            await axios
                .get("/api/getLatestImages")
                .then((response) => {
                    this.images = response.data;
                })
                .catch((error) => {
                    this.loaded = false;
                    console.error(error);
                });
        },
    },
    created() {
        this.setIntervalSlider("right");
        this.getLatestImages();
    },
};
</script>

<style lang="scss">
$color-arrow: white;
$color-slideindicator: yellow;
$color-playbutton: brown;
$color-pausebutton: #580843;
$controls-height-width: 20px;
$controls-innerchild-right-margin: 15px;
$controls-pauseplay-topdown-margin: 10px;
$controls-pauseplay-font-size: 20px;
$controls-squares-font-size: 15px;
$controls-squares-active-backgroundcolor: #58584f;
$controls-squares-active-font-color: white;

$font-weight-light: 400;
$font-weight-bold: 700;
$white: #fff;
$grey: #2b2b2b;

#itb-slider {
    box-shadow: 0px 0px 7px 0px rgb(0 0 0 / 20%);
    position: relative;
    overflow: hidden;
    height: inherit;
    width: inherit;

    .itb-arrow-left,
    .itb-arrow-right {
        color: rgb($white, 80%);
        position: absolute;
        bottom: 0;
        cursor: pointer;
        margin-bottom: 15px;

        i {
            font-size: 2rem;
        }
    }

    .itb-arrow-left {
        z-index: 1;
        left: 0;
    }

    .itb-arrow-right {
        right: 0;
    }

    .controls {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        margin-bottom: 7px;
        width: 90%;

        .options {
            cursor: pointer;
            float: left;
            margin: 20px;
            color: $white;
            font-size: 1.125rem;
            line-height: 1.5rem;
            font-weight: $font-weight-light;
            position: relative;

            span.number {
                font-weight: $font-weight-bold;
                margin-right: 23px;
            }

            &.active {
                font-weight: $font-weight-bold;

                &:after {
                    content: "";
                    width: 100%;
                    height: 3px;
                    background-color: $grey;
                    position: absolute;
                    bottom: -9px;
                    left: 0;
                }
            }
        }

        .squares {
            div {
                height: $controls-height-width;
                width: $controls-height-width;
                line-height: $controls-height-width;
                text-align: center;
                margin-right: $controls-innerchild-right-margin;
                display: inline-block;
                background-color: $color-slideindicator;
                border-radius: 50%;
                cursor: pointer;
                font-size: $controls-squares-font-size;
            }
            .active {
                background-color: $controls-squares-active-backgroundcolor;
                color: $controls-squares-active-font-color;
            }
        }

        .pauseplay {
            display: flex;
            justify-content: center;
            margin: $controls-pauseplay-topdown-margin 0;
            font-size: $controls-pauseplay-font-size;
            div {
                display: inline-block;
                height: $controls-height-width;
                line-height: $controls-height-width;
                width: $controls-height-width;
                text-align: center;
                border-radius: 50%;
                cursor: pointer;
                margin-right: $controls-innerchild-right-margin;
            }
            .play {
                color: $color-playbutton;
            }
            .pause {
                color: $color-pausebutton;
            }
        }
    }
}
</style>
